import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { cloneDeep, sortBy } from 'lodash';

import { ITicketType } from '../../../../interfaces/ticket-type.interface';
import { CheckListsValidators } from '../../../../check-lists.validators';
import { HDTicketTypesToken } from '../../check-lists.constant';
import { ISelectableTicketType } from '../../../../interfaces/selectable-ticket-type.interface';

@Component({
  selector: 'app-create-local-checklist-dialog',
  templateUrl: './create-local-checklist-dialog.component.html',
  styleUrls: ['./create-local-checklist-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CreateLocalChecklistDialogComponent {
  form: UntypedFormGroup = this.fb.group({
    name: ['', Validators.required],
    hdTicketTypes: [[], CheckListsValidators.requiredArray],
  });

  selectedHDTicketTypes: ITicketType[];
  cloneDeep = cloneDeep;

  constructor(
    private fb: UntypedFormBuilder,
    public activeModal: NgbActiveModal,
    @Inject(HDTicketTypesToken) public hdTicketTypes: ITicketType[]
  ) {}

  handleSubmit(): void {
    this.activeModal.close(this.form.value);
  }

  sortBySelected(items: ISelectableTicketType[]): ISelectableTicketType[] {
    return sortBy(items, (item: ISelectableTicketType) => !item.checked);
  }

  handleChangeTicketType(selectedHDTicketTypes: ITicketType[]): void {
    this.form.patchValue({
      hdTicketTypes: selectedHDTicketTypes.map((tt) => tt.id),
    });
  }
}
